/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import React, { useContext, useEffect } from 'react';
import ConfigContext from '../../../../contexts/ConfigContext';
import { ContactCardList, ContactCardListItem } from './style';
import ContactCardItem from '../ContactCardItem';

const ContactCardListComponent = ({contactCards}) => {

  const { error } = useContext(ConfigContext)

  return (
    <>
      <ContactCardList>
        {contactCards ? contactCards.sort((a, b) => a.key.split('-')[3] - b.key.split('-')[3]).map(({
          title,
          subtitle,
          buttonLink,
          key,
          footerText
        }) => (
          <ContactCardListItem key={title} itensCount={contactCards.length}>
            <ContactCardItem
              title={title}
              subtitle={subtitle}
              button={buttonLink}
              order={key.split('-')[3]}
              footerText={footerText}
              error={error}
            />
          </ContactCardListItem>
          )) : ''}
      </ContactCardList>
    </>
  )
};

export default ContactCardListComponent;